import axios from 'axios';
import baseurl from './customURl';







// *****************************SuperAdmin ____ superadmintoken****************************************************** 

export const GetLogo = async () => {



    try {
        const response = await axios.get(`${baseurl}/api/superadmin/get-logo`);

        if(response){
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};



export const GetAllroles = async () => {
    const token = localStorage.getItem('superadmintoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/superadmin/getAllRoles`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        return error.response;
    }
};






export const GetUserData = async () => {
    const token = localStorage.getItem('token');
    // const token = JSON.parse(response);
    console.log(token);

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/getUserData`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};


export const showroles = async () => {
    const token = localStorage.getItem('superadmintoken');

    if (!token) {
        return console.error('No Sanctum token found');
    }

    try {
        const response = await axios.get(`${baseurl}/api/superadmin/showadmins`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response.data;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};


// fetch current login marchant data 

export const MerchantDetails = async () => {
    const tokenString = localStorage.getItem('Merchanttoken');
    if (!tokenString) {
        console.error('No token found in localStorage');
        return null;
    }

    // No need to use JSON.parse since the token is a plain string
    const token = tokenString;

    try {
        const response = await axios.get(`${baseurl}/api/admin/merchant-totalSales`, {
        // const response = await axios.get(`${baseurl}/api/auth-merchant`, {

            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        
        if (response) {
            return response.data;
        }
    } catch (error) {
        return error.response;
    }
};


// fetch current login marchant data 

export const getTotalSales = async () => {
    const tokenString = localStorage.getItem('Merchanttoken');
    if (!tokenString) {
        // console.error('No token found in localStorage');
        return null;
    }

    // No need to use JSON.parse since the token is a plain string
    const token = tokenString;

    try {
        const response = await axios.get(`${baseurl}/api/admin/get-sales-data`, {
        // const response = await axios.get(`${baseurl}/api/auth-merchant`, {

            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        
        if (response) {
            return response.data;
        }
    } catch (error) {
        return error.response;
    }
};


// fetch current login marchant data 

export const getNewOrders = async () => {
    const tokenString = localStorage.getItem('Merchanttoken');
    if (!tokenString) {
        console.error('No token found in localStorage');
        return null;
    }

    // No need to use JSON.parse since the token is a plain string
    const token = tokenString;

    try {
        const response = await axios.get(`${baseurl}/api/admin/getNewOrders-graph`, {
        // const response = await axios.get(`${baseurl}/api/auth-merchant`, {

            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        
        if (response) {
            return response.data;
        }
    } catch (error) {
        return error.response;
    }
};

export const GetNewCustomer_graph = async () => {
    const tokenString = localStorage.getItem('Merchanttoken');
    if (!tokenString) {
        console.error('No token found in localStorage');
        return null;
    }

    // No need to use JSON.parse since the token is a plain string
    const token = tokenString;

    try {
        const response = await axios.get(`${baseurl}/api/admin/getNewusers-graph`, {
        // const response = await axios.get(`${baseurl}/api/auth-merchant`, {

            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        
        if (response) {
            return response.data;
        }
    } catch (error) {
        return error.response;
    }
};


// Import UserDetails

export const ImportCustomerDetails = async (login) => {

   

    try {
        const response = await axios.get(`${baseurl}/api/auth-users`, {
            headers: {
                Authorization: `Bearer ${login}`
            }
        });
        if(response){
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
        return error.response;
    }

    
};

// Show_Users_MainCategory

export const Show_Users_MainCategory = async () => {

   

    try {
        const response = await axios.get(`${baseurl}/api/all_maincategories`, {
           
        });

        if(response){
            return response.data;
        }

    } catch (error) {
        return error.response;
    }

    
};

// Show_users_SubCategory

export const Show_users_SubCategory = async () => {
    try {
        const response = await axios.get(`${baseurl}/api/all_subcategories`, {
           
        });

        if(response){
            return response.data;
        }

    } catch (error) {
        return error.response;
    }
};

// Show_Users_Sub_SubCategory

export const Show_Users_Sub_SubCategory = async () => {
    try {
        const response = await axios.get(`${baseurl}/api/all_SubSubCategory`, {
           
        });

        if(response){
            return response.data;
        }

    } catch (error) {
        return error.response;
    }
};

// getsubCategoryItem

export const getAllItem = async ({id,type}) => {
    console.log(id,type);
    
    try {
        const response = await axios.get(`${baseurl}/api/getItems/${id}/${type}`);

        if(response){
            console.log(response);
            return response.data;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
        return error.response;
    }
};


// GetVariantDetails

export const GetVariantDetails = async (Variantid,Varient_type,purchase_item_id,stock_id ,area_pin) => {
    console.log(Variantid);
    console.log(Varient_type);
    console.log(purchase_item_id);
    console.log(stock_id);
    console.log(area_pin);


    
    
    try {
        const response = await axios.get(`${baseurl}/api/getVariantsDetails/${Variantid}/${Varient_type}/${purchase_item_id}/${stock_id}/${area_pin}`); 

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
        return error.response;
    }
};


// getdesktopUIMainBanner

export const getdesktopUIMainBanner = async () => {


    try {
        const response = await axios.get(`${baseurl}/api/getDesktopMainBannersInCustomerUI`, {
          
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        return error.response;
    }
};


// getMainBannerUptoOfferItems

export const getMainBannerUptoOfferItems = async (bannerId) => {


    try {
        const response = await axios.get(`${baseurl}/api/getMainBannerUptoOfferItems/${bannerId}`);

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        return error.response;
    }
};


// getFeaturedBannerUptoOfferItems

export const getFeaturedBannerUptoOfferItems = async (ImageId) => {


    try {
        const response = await axios.get(`${baseurl}/api/getFeaturedBannerUptoOfferItems/${ImageId}`);

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        return error.response;
    }
};





// getUptoOfferItems


export const getUptoOfferItems = async () => {


    try {
        const response = await axios.get(`${baseurl}/api/getDesktopMainBannersInCustomerUI`, {
          
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        return error.response;
    }
};





// Get Main Category

export const ShowMainCategory = async () => {
    const token = localStorage.getItem('Merchanttoken');

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/all_maincategories`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response.data;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};


// Get SubCategory

export const ShowSubCategory = async () => {
    const token = localStorage.getItem('Merchanttoken');
    console.log(token);
    

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/all_subcategories`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response.data;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};



// Get GetMerchantDetails

export const GetMerchantDetails = async () => {
    const token = localStorage.getItem('Merchanttoken');
    console.log(token);
    

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/auth-merchant`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response.data;
        }

    } catch (error) {
        return error.response;
    }
};


// Get Sub_subCategory

export const Show_Sub_SubCategory = async () => {
    const token = localStorage.getItem('Merchanttoken');


    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/all_SubSubCategory`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response.data;
        }

    } catch (error) {
        return error.response;
    }
};




export const GetUserAddresses = async () => {
    const response = localStorage.getItem('token');
    const token = JSON.parse(response);
    console.log(token);

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/getUseraddresses`, {
            headers: {
                Authorization: `Bearer ${token.token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};



export const GetItemDetails = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getItems/all`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};


export const GetUsersDetails = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getUsers`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};


export const getAllOrders = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllOrders`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};

// GetAllConfirmPayments

export const GetAllConfirmPayments = async () => {
    const token = localStorage.getItem('Merchanttoken');


    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getConfirmPayments`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};

// GetPaymentDetailResponse

export const GetPaymentDetailResponse = async (orderId) => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/GetPaymentDetailResponse/${orderId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        console.log(response);
        

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};


// AllDeliveryExecutive_retrive


export const AllDeliveryExecutive_retrive = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllExecutive`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};

// OrderItem

export const OrderItem = async (item) => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/OrderItems/${item}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};

// order Delivery 

export const order_DeliveryData = async (item) => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/OrderDelivery/${item}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};

// order_Confirm_Payment_details

export const order_Confirm_Payment_details = async (item) => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/ConfirmOrder/${item}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};


export const GetdeliveryCargesOnDistance = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getDeliveryChargesOnDistance`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};


export const GetdeliveryCargesOnValue = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getDeliveryChargesOnValue`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};

// getwareHouses

export const GetwareHouses = async () => {
    const token = localStorage.getItem('Merchanttoken');


    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getwarehouses`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
        return error.response;
    }
};


// getAllPincode


export const getAllPincode = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllPinCodes`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};




// VerifyPinCode


export const VerifyPinCode = async ($pincode) => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/verifyPincode/${$pincode}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};

// Supplier

export const getAllSupplier = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllSupplier`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};


// brand

export const getAllBrand = async () => {
    const token = localStorage.getItem('Merchanttoken');


    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllBrand`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
        return error.response;
    }
};


// brand

export const getAllUnit = async () => {
    const token = localStorage.getItem('Merchanttoken');


    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllunit`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
        return error.response;
    }
};


// getAllPurchase

export const getAllPurchase = async () => {
    const token = localStorage.getItem('Merchanttoken');


    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllpurchase`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
        return error.response;
    }
};


// getAllPurchaseItems


export const getAllPurchaseItems = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllPurchaseItems`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};



// getAllStockItem

export const getAllStockItem = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllStockItems`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};


// getAllLooseVariantsRegarding

export const getAllLooseVariantsRegarding = async (variantId) => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllLooseVariantsRegarding/${variantId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
        return error.response;
    }
};





// getAllPacketStock

export const getAllPacketStock = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllpacketStock`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};



// getAllLooseStock

export const getAllLooseStock = async () => {
    const token = localStorage.getItem('Merchanttoken');


    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllloose_stock`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
        return error.response;
    }
};



// getAllPacketStock

export const getAllLooseVarient = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllloose_Varient`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};



export const getAllLooseVarientForCreatingOFFER = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllLooseVarientForCreatingOFFER`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};


export const getAllPacketVarientForCreatingOFFER = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllPacketVarientForCreatingOFFER`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};



// getAllLooseStock

export const getAllPacketVarient = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllpacket_Varient`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};


// getAllLooseStock

export const getAllDiscounts = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllDiscounts`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};

// get_gst

export const getAllGST = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllgstRates`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};

// GetAllCreatedItems


export const GetAllCreatedItems = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllItems`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};



// GetAllCreatedItemsforCreatingpacketVarients


export const GetAllCreatedItemsforCreatingpacketVarients = async () => {
    const token = localStorage.getItem('Merchanttoken');


    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/GetAllCreatedItemsforCreatingpacketVarients`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
        return error.response;
    }
};


// GetAllCreatedItemsForCreatingVarients


export const GetAllCreatedItemsForCreatingVarients = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/GetAllCreatedItemsForCreatingVarients`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);

        return response.error;
    }
};

// GetAllCreatedDeliveryExecutive


export const GetAllCreatedDeliveryExecutive = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/GetAllCreatedDeliveryExecutive`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};

// GetAllOffers

export const GetAllOffers = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllOffers`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};


// Banners ****************************************** Banner ********************************************* Banner ********************

// GetDesktopMainBanners

export const GetDesktopMainBanners = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getdesktop-mainBanner`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        return error.response;
    }
};



// GetDesktopFeaturedBanners

export const GetDesktopFeaturedBanners = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getdesktop-FeaturedBanner`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        return error.response;
    }
};

// GetDesktopFeaturedZoneImageResponse

export const GetDesktopFeaturedZoneImageResponse = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/GetDesktopFeaturedZoneImageResponse`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        return error.response;
    }
};


// GetOfferZone

export const GetOfferZone = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/GetOfferZone`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        return error.response;
    }
};



// GetAllOffers

export const getActiveFeaturedZone = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getActiveFeaturedZone`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};

// CustomerUIFeaturedBanners

// getDesktopFeaturedBannersInCustomerUI


export const getDesktopFeaturedBannersInCustomerUI = async () => {


    try {
        const response = await axios.get(`${baseurl}/api/getDesktopFeaturedBannersInCustomerUI`);

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        return error.response;
    }
};



// getDesktopHomeManagementCategory

export const getDesktopHomeManagementCategory = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getDesktopHomeManagementCategory`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);

        return error.response;
    }
};





export const GetAllVarients = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllVarients`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};

// getAllAddress

export const getAllAddress = async () => {
    const token = localStorage.getItem('token');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/getUseraddresses`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);

        return error.response;
    }
};

// getAllCartItems


export const getAllCartItems = async () => {
    const token = localStorage.getItem('token');


    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/getAllCartItems`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        console.log(response);
        

        if(response){
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
        return error.response;
    }
};

// getAllActivePincodes

export const getAllActivePincodes = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllActivePincodes`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};

// /getAllDeliveyDates

export const getAllDeliveyDates = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllDeliveyDates`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};

// getAllNotAssignedOrder


export const getAllNotAssignedOrder = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAllNotAssignedOrder`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        return error.response;
    }
};

// getCancelledRequest

export const getCancelledRequest = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getCancelledRequest`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};


// getOnDeliveryExecutive
export const getOnDeliveryExecutive = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getOnDeliveryExecutive`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {

        console.error('Error fetching tables', error);
        return error.response;
    }
};

// GetExecutivesOrderHistory
export const GetExecutivesOrderHistory = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getExecutiveOrderhistory`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};

// checkPincodeAvailability

export const checkPincodeAvailability = async (pincode) => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");


    try {
        const response = await axios.get(`${baseurl}/api/checkPincodeAvailability/${pincode}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};


// /getAvailableDeliveryExecutives


export const getAvailableDeliveryExecutives = async () => {
    const token = localStorage.getItem('Merchanttoken');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/admin/getAvailableDeliveryExecutive`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};


// getUserOrders


export const getUserOrders = async () => {
    const token = localStorage.getItem('token');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/getUIOrders`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};


// getOrderDetail

export const getOrderDetail = async (orderId) => {
    const token = localStorage.getItem('token');

    console.log("chala");

    if (!token) {
        return console.error('No Sanctum token found');
        
    }

    try {
        const response = await axios.get(`${baseurl}/api/getOrderDetail/${orderId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);
    }
};





// getDesktopHomeManagementCategoryInCustomerUI

export const getDesktopHomeManagementCategoryInCustomerUI = async () => {
 

    try {
        const response = await axios.get(`${baseurl}/api/getDesktopHomeManagementCategoryInCustomerUI`);

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {
        console.error('Error fetching tables', error);

        return error.response;
    }
};







// ******************************************** NEW PROJECT ******************************************************************************


export const getSkillList = async () => {

    try {
        const response = await axios.get(`${baseurl}/Skill/GetSkillList


`, {
            headers: {
                // Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {

        return error.response;
    }
};

export const getStaffSkillList = async () => {

    try {
        const response = await axios.get(`${baseurl}/staffSkills/GetStaffSkillsList



`, {
            headers: {
                // Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {

        return error.response;
    }
};



export const getAllStaff = async () => {

    try {
        const response = await axios.get(`${baseurl}/staff/GetStaffList
`, {
            headers: {
                // Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {

        return error.response;
    }
};



export const getEventList = async () => {

    try {
        const response = await axios.get(`${baseurl}/eventDetails/GetEventDetailsList

`, {
            headers: {
                // Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {

        return error.response;
    }
};

export const available_Staff = async () => {

    try {
        const response = await axios.get(`${baseurl}/DutyAllotment/

`, {
            headers: {
                // Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {

        return error.response;
    }
};


export const GetEventDeatils_AvailableStaffs = async (EventDetailsId) => {


    try {
        const response = await axios.get(`${baseurl}/DutyAllotment/GetAvailableStaff/${EventDetailsId}

`, {
            headers: {
                // Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {

        return error.response;
    }
};


export const getAllArea = async () => {

    try {
        const response = await axios.get(`${baseurl}/Area/GetArea


`, {
            headers: {
                // Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {

        return error.response;
    }
};

// getArea_ByEventDetailsID

export const getArea_ByEventDetailsID = async (EventDetailId) => {

    try {
        const response = await axios.get(`${baseurl}/Area/GetAreasList/${EventDetailId}
`, {
            headers: {
                // Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {

        return error.response;
    }
};



export const getReservedAllotedStaff = async (DeputyCheckpointId) => {



    try {
        const response = await axios.get(`${baseurl}/Allotment/GetReservedAllottedStaff/${DeputyCheckpointId}
`, {
            headers: {
                // Authorization: `Bearer ${token}`
            }
        });

           return response;

    } catch (error) {

        throw error

    }
};


export const getDuttyAllotement = async () => {

    try {
        const response = await axios.get(`${baseurl}/DutyAllotment/allotted-Staff


`, {
            headers: {
                // Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {

        return error.response;
    }
};

export const getCommunities = async () => {

    try {
        const response = await axios.get(`${baseurl}/Community/GetCommunity


`, {
            headers: {
                // Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {

        return error.response;
    }
};



export const getGeoTag = async () => {

    try {
        const response = await axios.get(`${baseurl}/geoTag/GetGeoTagGenerationRequestList

`, {
            headers: {
                // Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {

        return error.response;
    }
};


export const getStaff_geoTagList_fromDataBase = async () => {

    try {
        const response = await axios.get(`${baseurl}/geotag/GetGeoTagList

`, {
            headers: {
                // Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {

        return error.response;
    }
};

// Deputy Location

export const Deputy__Location = async () => {

    try {
        const response = await axios.get(`${baseurl}/geotag/GeoTagLocationStaffInformation


`, {
        });

        console.log(response);
            return response;

    } catch (error) {

throw error;
    }
};




// getEvent_AllottedData

export const getEvent_AllottedData = async (selectedEventId) => {

    try {
        const response = await axios.get(`${baseurl}/Allotment/GetAllottedStaff/${selectedEventId}

`, {
            headers: {
                // Authorization: `Bearer ${token}`
            }
        });

            console.log(response);


        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {

        return error.response;
    }
};

// GetAvailableStaffs


export const GetAvailableStaffs = async (value) => {

    try {
        const response = await axios.get(`${baseurl}/Allotment/GetManualStaffAvailability/${value}

`, {
            headers: {
                // Authorization: `Bearer ${token}`
            }
        });


   return response;

    } catch (error) {

        throw error
    }
};



export const GetReservedStaffList = async () => {

    try {
        const response = await axios.get(`${baseurl}/staff/GetReservedStaffList

`, {
            headers: {
                // Authorization: `Bearer ${token}`
            }
        });


   return response;

    } catch (error) {

        throw error
    }
};






export const getAllEvents = async () => {

    try {
        const response = await axios.get(`${baseurl}/EventType/GetEventType


`, {
            headers: {
                // Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {

        return error.response;
    }
};


export const getDistrictList = async () => {

    try {
        const response = await axios.get(`${baseurl}/District/GetDistrict


`, {
            headers: {
                // Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {

        return error.response;
    }
};



export const getStateList = async () => {

    try {
        const response = await axios.get(`${baseurl}/States/GetStates



`, {
            headers: {
                // Authorization: `Bearer ${token}`
            }
        });

        if(response){
            console.log(response);
            return response;
        }

    } catch (error) {

        return error.response;
    }
};
